import { QuickbooksCustomersGetResponseType } from "@sellar-io/api-v2/types";
import { useMutation } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2Request } from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useQuickbooksCustomers = () => {
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationKey: [user?.uid, business?.id, ServerStateKeys.QuickbooksCustomers],
    mutationFn: () =>
      apiV2Request({
        user,
        business,
        method: "get",
        responseType: "text",
        path: `quickbooks/customers`,
      }).then((data) => data.data as QuickbooksCustomersGetResponseType),
  });
};
